import type { LucideIcon } from "lucide-react-native";
import {
  Pill,
  Shield,
  Heart,
  Droplet,
  Syringe,
  Circle,
  Droplets,
  Calendar,
  MoreHorizontal,
  Scissors,
  Thermometer,
  ArrowLeftRight,
  CircleSlash,
} from "lucide-react-native";

export type ContraceptionMethod =
  | "birth_control_pill"
  | "female_condom"
  | "male_condom"
  | "hormonal_iud"
  | "copper_iud"
  | "contraceptive_implant"
  | "contraceptive_ring"
  | "contraceptive_injection"
  | "contraceptive_patch"
  | "spermicide"
  | "female_sterilization"
  | "vasectomy"
  | "withdrawal"
  | "andro_switch"
  | "thermal_underwear"
  | "contraceptive_slip"
  | "fertility_awareness"
  | "abstinence"
  | "foam"
  | "calendar_method"
  | "other";

export type ContraceptionSex = "AFAB" | "AMAB" | "both";

export interface ContraceptionMethodOption {
  id: ContraceptionMethod;
  labelKey: string;
  icon: LucideIcon;
  sex: ContraceptionSex;
}

const labelKeyFor = (id: ContraceptionMethod): string =>
  `med_history.gynae.contraception.method.${id}`;

export const CONTRACEPTION_METHOD_OPTIONS: ContraceptionMethodOption[] = [
  // AFAB-only (anatomy-specific or hormonal/AFAB-targeted)
  {
    id: "birth_control_pill",
    labelKey: labelKeyFor("birth_control_pill"),
    icon: Pill,
    sex: "AFAB",
  },
  {
    id: "female_condom",
    labelKey: labelKeyFor("female_condom"),
    icon: Shield,
    sex: "AFAB",
  },
  {
    id: "hormonal_iud",
    labelKey: labelKeyFor("hormonal_iud"),
    icon: Heart,
    sex: "AFAB",
  },
  {
    id: "copper_iud",
    labelKey: labelKeyFor("copper_iud"),
    icon: Droplet,
    sex: "AFAB",
  },
  {
    id: "contraceptive_implant",
    labelKey: labelKeyFor("contraceptive_implant"),
    icon: Syringe,
    sex: "AFAB",
  },
  {
    id: "contraceptive_ring",
    labelKey: labelKeyFor("contraceptive_ring"),
    icon: Circle,
    sex: "AFAB",
  },
  {
    id: "contraceptive_injection",
    labelKey: labelKeyFor("contraceptive_injection"),
    icon: Syringe,
    sex: "AFAB",
  },
  {
    id: "contraceptive_patch",
    labelKey: labelKeyFor("contraceptive_patch"),
    icon: Droplets,
    sex: "AFAB",
  },
  {
    id: "female_sterilization",
    labelKey: labelKeyFor("female_sterilization"),
    icon: Shield,
    sex: "AFAB",
  },
  // AMAB-only
  {
    id: "male_condom",
    labelKey: labelKeyFor("male_condom"),
    icon: Shield,
    sex: "AMAB",
  },
  {
    id: "vasectomy",
    labelKey: labelKeyFor("vasectomy"),
    icon: Scissors,
    sex: "AMAB",
  },
  {
    id: "andro_switch",
    labelKey: labelKeyFor("andro_switch"),
    icon: Thermometer,
    sex: "AMAB",
  },
  {
    id: "thermal_underwear",
    labelKey: labelKeyFor("thermal_underwear"),
    icon: Thermometer,
    sex: "AMAB",
  },
  {
    id: "contraceptive_slip",
    labelKey: labelKeyFor("contraceptive_slip"),
    icon: Thermometer,
    sex: "AMAB",
  },
  // Both — either partner can use, apply, or report
  {
    id: "spermicide",
    labelKey: labelKeyFor("spermicide"),
    icon: Droplets,
    sex: "both",
  },
  { id: "foam", labelKey: labelKeyFor("foam"), icon: Droplets, sex: "both" },
  {
    id: "withdrawal",
    labelKey: labelKeyFor("withdrawal"),
    icon: ArrowLeftRight,
    sex: "both",
  },
  {
    id: "fertility_awareness",
    labelKey: labelKeyFor("fertility_awareness"),
    icon: Calendar,
    sex: "AMAB",
  },
  {
    id: "calendar_method",
    labelKey: labelKeyFor("calendar_method"),
    icon: Calendar,
    sex: "AFAB",
  },
  {
    id: "abstinence",
    labelKey: labelKeyFor("abstinence"),
    icon: CircleSlash,
    sex: "both",
  },
  {
    id: "other",
    labelKey: labelKeyFor("other"),
    icon: MoreHorizontal,
    sex: "both",
  },
];
